export const COLUMN_HINTS = {
  prev_esp: 'Общее время всех сеансов передачи данных (включая неудачные) с момента последней успешной передачи до текущего момента',
  sum_esp: 'Суммарное время хранения данных между последовательными сеансами отправки',
  calc_value: 'Расчётное значение объёма потребления в литрах',
  raw_value: 'Количество зарегистрированных импульсов, полученных с устройства',
};

export const LIMIT = 20;

export const INITIAL_VALUES = { serialId: '', typeKey: '' };

export const TYPE_OPTIONS = [
  { value: 'controller', label: 'Контроллер' },
  { value: 'counter', label: 'Счётчик' },
  { value: 'sensor', label: 'Датчик' },
];

export const TYPE_NAME_TO_KEY = {
  Контроллер: 'controller',
  Счётчик: 'counter',
  Датчик: 'sensor',
};

export const CONTROLLER_ONLY_KEYS = new Set(['device_version', 'voltage', 'signal', 'reset_count', 'prev_esp', 'sum_esp', 'error_description']);

export const COUNTER_ONLY_KEYS = new Set(['calc_value', 'raw_value']);

export const ATTACHED_DEVICE_KEYS = new Set(['subtype_name', 'output_type_name', 'm_multiplier', 'm_add']);
